import React from 'react';
import { Container, CenterDiv, LogoImage  } from './styles.js';
import RegisterResidentView from '../../views/RegisterResident/index.jsx';

import logo from '../../assets/LogoPos2.png';
function RegisterResident() {

    return (
      <Container>
  
      
        <CenterDiv>
     <LogoImage src={logo} alt="Logo" /> 
        <h4 style={{marginTop: '20px'}}>FORMULÁRIO DE INSCRIÇÃO PARA O PROCESSO SELETIVO DE RESIDÊNCIA MÉDICA R4 EM PATOLOGIA</h4>
          <RegisterResidentView />
        </CenterDiv>
      </Container>
    );
}

export default RegisterResident;
